import type { AtlasShortcut } from "@/components/ecv2/components/whiteboardEC/runtime/keymap";

export const ATLAS_CHROME_SHORTCUTS = {
  navigation: { label: "Show / hide the navigation pane", keys: ["Mod+[Backslash]"] },
  supportingPane: { label: "Show / hide the supporting pane", keys: ["Mod+Alt+[Backslash]"] },
  find: { label: "Find on the canvas", keys: ["Mod+K"] },
} as const satisfies Readonly<Record<string, AtlasShortcut>>;
